var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{staticClass:"pointer text-secondary mr-1",attrs:{"id":_vm.roomId + '-' + _vm.rate.rateTypeId + '-status-popover-target'}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'info-circle'],"fixed-width":""}})],1),_c('b-popover',{attrs:{"target":_vm.roomId + '-' + _vm.rate.rateTypeId + '-status-popover-target',"triggers":"hover","placement":"top"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.status.key))]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.status.value)+" ")]),_c('span',{class:[
      _vm.rate.rateStatus == _vm.RateQuoteStatus.Success &&
      _vm.rate.status == _vm.QuoteStatus.Success
        ? 'text-success'
        : 'text-danger',
    ]},[_vm._v(_vm._s(_vm.status.key))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }